<template>
  <div class="app">
    <div class="top">
      <div class="bgimg">
        <img :src="bg" alt="背景" />
      </div>
      <div class="nav">
        <div class="logo">
          <img :src="logo" alt="logo"/>
        </div>
        <div class="nav_list">
          <div class="list" @click="activeId=item.id" v-for="(item,index) in navList">
            <span :class="item.id==activeId?'act':''">{{item.title}}</span>
          </div>
        </div>
      </div>
    </div>
   <div class="content">
     <div class="box" v-if="activeId==1">
        <img :src="erweima" alt="商家" />
        <div class="slogn">微信扫码打开小程序</div>
<!--       <div class="btn">-->
<!--         <button class="ios">ios下载</button>-->
<!--         <button class="android">android下载</button>-->
<!--       </div>-->
         <div class="cp">
           <img style="width: 100%; margin-top:.7rem" :src="about" />
           <div class="cpList" v-for="item in cpList">
             <img :src="item.cpimg" />
             <div>
               {{item.text}}
             </div>
           </div>
         </div>
     </div>
     <div class="box" v-if="activeId==2">
       <img :src="logo_sj" alt="商家" />
       <div class="slogn">菜小呆商家端</div>
       <div class="btn">
         <button @click="showact('IOS版本正在路上！敬请期待')" class="ios">ios下载</button>
         <button @click="appload(shopAppUrl)" class="android">android下载</button>
       </div>
     </div>
     <div class="box" v-if="activeId==3">
       <img :src="logo_ps" alt="配送" />
       <div class="slogn">菜小呆配送端</div>
       <div class="btn">
         <button @click="showact('IOS版本正在路上！敬请期待')" class="ios">ios下载</button>
         <button @click="appload(deliveryAppUrl)" class="android">android下载</button>
       </div>
     </div>
   </div>
  <div class="footer">
       <div class="left">
         <div class="tit">
           商务合作咨询热线：‭021-61732097‬
         </div>
         <div class="add">
           公司地址：上海嘉定区江桥镇西郊商务区C2区1555弄33号楼
         </div>
         <div class="bei">
           Copyright2020-2025 菜小呆 沪ICP备17017242
         </div>
    </div>
  </div>
  </div>
</template>
<script>
    import logo from '@/assets/image/logo.png';
    import bg from '@/assets/image/bg_mobile.png';
    import logo_sj from '@/assets/image/logo_sj.png';
    import logo_ps from '@/assets/image/logo_ps.png';
    import erweima from '@/assets/image/erweima.jpg';
    import cp1 from '@/assets/image/cp1.png';
    import cp2 from '@/assets/image/cp2.png';
    import cp3 from '@/assets/image/cp3.png';
    import about from '@/assets/image/about.png';
    export default {
        name: "mobile",
        data(){
            return{
                logo:logo,
                about:about,
                bg:bg,
                cp1:cp1,
                cp2:cp2,
                cp3:cp3,
                erweima:erweima,
                logo_sj:logo_sj,
                logo_ps:logo_ps,
                activeId:1,
                deliveryAppUrl:undefined,
                shopAppUrl:undefined,
                cpList:[
                    {
                        cpimg:cp1,
                        text:"上海先瀛网络科技有限公司成立于2018年，在”爱·感恩·责任”的企业文化中，始终坚持以客户为中心。"
                    },
                    {
                        cpimg:cp2,
                        text:"“菜小呆”是先瀛主要经营的高校校园生活服务平台，为全国大学生提供懒人服务。在迈向全国高校的路途中，我们着重挖掘和培养人才，创造发展空间，持续提升伙伴价值，提高工作和生活质量。为工作伙伴提供实现价值、财务自由和梦想的平台。"
                    },
                    {
                        cpimg: cp3,
                        text: "总公司上海诸宸实业有限公司成立于2004年10月，年营业收入约8亿元。目前为止是华东、华北地区沃尔玛最大生鲜供应商之一，且全面入驻华东地区大润发家乐福、世纪联华、易初莲花等商超，同时给上海各大政府食堂以及园区食堂优质食材供应。"
                    }
                ],
                navList:[
                    {
                        title:"首页",
                        id:"1",
                    },
                    {
                        title:"商家端",
                        id:"2"
                    },
                    {
                        title:"配送端",
                        id:"3"
                    }
                ],
            }
        },
        created:function (e) {
            let id = this.$route.hash;
             if(id){
                 id=id.replace('#',"");
                 this.activeId=id;
             }
            if(navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)){
                (function(doc, win) {
                    var docEl = doc.documentElement,
                        resizeEvt = "orientationchange" in window ? "orientationchange" : "resize",
                        recalc = function() {
                            if (docEl.clientWidth > 750) {
                                docEl.style.fontSize = "100px";
                                doc.getElementById("app").style.width = "750px";
                            } else {
                                var width = docEl.clientWidth / 7.5;
                                docEl.style.fontSize = width + "px";
                                doc.getElementById("app").style.width = "auto";
                            }
                        };
                    if (!doc.addEventListener) return;
                    win.addEventListener(resizeEvt, recalc, false);
                    doc.addEventListener("DOMContentLoaded", recalc, false);
                })(document, window);
            }else {
                this.$router.push({path:"/"});
            }
            this.getCode();
        },
        methods:{
            showact(msg){
                alert(msg);
            },
            appload(url){
                    window.open(url);
            },
            getCode(){
                this.$axios.get('/version/getDeliveryAppUrl').then(response =>{
                    if(response.data.code==0){
                        this.deliveryAppUrl=response.data.data;
                    }
                }).catch(function (error) { // 请求失败处理
                    console.log(error);
                });
                this.$axios.get('/version/getShopAppUrl').then(response =>{
                    if(response.data.code==0){
                        this.shopAppUrl=response.data.data;
                    }
                }).catch(function (error) { // 请求失败处理
                    console.log(error);
                });
            }
        }
    }

</script>

<style scoped>
  .content .cp {
   width: 100%;
  }
  .content .cpList{
    margin-bottom:.3rem;
    text-align: center;
    padding: .40rem 0;
    height: max-content;
    background: #FFFFFF;
    box-shadow: 1px 4px 18px 0px rgba(255, 215, 114, 0.28);
    border-radius: 20px;
  }
  .content .cpList div{
    padding: 0 .4rem;
    margin: .2rem auto;
    text-align: left;
    color: #333;
    font-size: .28rem;
    font-weight: 400;
    line-height: .48rem;
  }
  .content .box .cpList img{
    border: none;
    width: .7rem;
  }
  .app{
    width: 100%;
    min-height: 14.55rem;
    position: relative;
  }
  .content{
    min-height: 4.47rem;
    padding: 0 .3rem;
    text-align: center;
  }
  .content .box .slogn{
    color: #333333;
    font-size: .32rem;
    font-weight: bold;
  }
  .content .box>img{
    width: 2rem;
    height: 2rem;
    border: .05rem solid #FFB600;
    border-radius: .3rem;
  }
  .nav_list{
     display: flex;
     justify-content: flex-end;
   }
  .nav_list .list{
    line-height: .63rem;
    margin-left: .5rem;
  }
  .nav_list .list .act{
    color: #730C0A;
    font-weight: bold;
  }
  .top{
    width: 100%;
    height: 7.98rem;
    position: relative;
  }
  .bgimg{
    position: absolute;
    top: 0;
    width: 100%;
    height: auto;
    z-index: -1;
  }
  .bgimg img{
    width: 100%;
  }
  .logo img{
    width: 1.9rem;
    height: auto;
  }
  .btn button{
    border: none;
    box-shadow: none;
    width: 2.5rem;
    font-size: .28rem;
    height: .7rem;
    border-radius: .10rem;
  }
  .btn button.ios{
    background: #8DBCFF;
  }
  .btn button.android{
    background: #FFD262;
  }
  .footer{
    padding-top: .2rem;
    /*position: absolute;*/
    width: 100%;
    height: 2rem;
    margin-top: .3rem;
    background: #F8F8F8;
    color: #666;
    font-size: .24rem;
    line-height: .4rem;
    text-align: center;
  }
  .nav{
    display: flex;
    justify-content: space-between;
    padding: .12rem .3rem;
    font-size: .28rem;
    color: #333333;
  }
</style>



// WEBPACK FOOTER //
// src/view/mobile.vue